import * as Sentry from '@sentry/react'
import { jwtDecode } from 'jwt-decode'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import { MessageModal } from '@/components/message-modal'

import { Account } from './account'
import { Company } from './company'

interface TokenPayload {
  exp: number
}

interface UserConfirmParams {
  type: 'account' | 'company'
  token: string
}

export function UserConfirm() {
  const { type, token } = useParams() as unknown as UserConfirmParams
  const [isValidToken, setIsValidToken] = useState<{
    valid: boolean
    message: string
  } | null>(null)

  const userConfirmTypes = useMemo(
    () => ({
      account: <Account token={token} />,
      company: <Company token={token} />,
    }),
    [type],
  )

  const verifyToken = useCallback(() => {
    try {
      const userData: TokenPayload = jwtDecode(token)
      const expDate = new Date(userData.exp * 1000)
      const actualDate = new Date()
      if (expDate < actualDate) {
        const formatedTokenDate = expDate
          .toLocaleString([], {
            dateStyle: 'short',
            timeStyle: 'short',
          })
          .replace(' ', ' às ')

        setIsValidToken({
          valid: false,
          message: `O token expirou em ${formatedTokenDate}, solicite um novo!`,
        })
      } else {
        setIsValidToken({ valid: true, message: '' })
      }
    } catch (e: any) {
      Sentry.captureException(e)
      setIsValidToken({ valid: false, message: 'Token inválido!' })
    }
  }, [token])

  useEffect(() => {
    if (userConfirmTypes[type]) verifyToken()
    else
      toast('Ocorreu um erro ao confirmar o usuário.', {
        type: 'error',
        autoClose: false,
      })
  }, [])

  if (!isValidToken) return <MessageModal title='Carregando...' message='' />

  if (!isValidToken.valid)
    return (
      <MessageModal title='Erro' message={isValidToken.message} type='error' />
    )

  return userConfirmTypes[type]
}
